module.exports = __webpack_public_path__ + "img/pickup-confirmation.fd9f3010.svg";